import { isPermissionKey, type PermissionKey, type PermissionSetDto } from '@gc/shared';

/**
 * Role-template client helpers (wave 3, SPEC §4 "Employee (+PermissionSet)").
 *
 * ASSIGNMENT IS A SNAPSHOT: choosing a template in the employee drawer copies
 * its permissions into the matrix CLIENT-SIDE and the save submits that copy —
 * the authoritative grant is always `Employee.permissions`. The link
 * (`permissionSetId`) rides along so the roles screen can count members and
 * offer the explicit "Apply to N employees" re-sync later.
 */

export const PERMISSION_SETS_PATH = '/permission-sets';

/**
 * A template's permissions as a matrix set.
 *
 * Filtered through `isPermissionKey` because reads are tolerant where writes
 * are strict: a template stored before a key was retired must fill the matrix
 * with what still exists rather than making the subsequent save 400.
 */
export function snapshotTemplate(
  template: Pick<PermissionSetDto, 'permissions'>,
): Set<PermissionKey> {
  return new Set(template.permissions.filter(isPermissionKey));
}

/**
 * `EmployeeDto` as the API actually answers since wave 3 — it carries the
 * template link. The shared DTO gains the field with a lead one-liner; until
 * then this widening is the single place the drawer reads it from.
 */
export interface EmployeeTemplateLink {
  permissionSetId?: string | null;
}
